import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { Obj } from 'types/common'

import * as apiUtils from '.'

const url = '/bom-config'

// ============================================================================
// Version API
// ============================================================================

export const getVersions = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/versions`, options)

export const getCurrentVersion = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/versions/current`, options)

export const getVersion = (id: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/versions/${id}`, options)

export const createVersion = (data: Obj) =>
  apiUtils.POST(`${url}/versions`, data)

export const duplicateVersion = (id: string, data: Obj) =>
  apiUtils.POST(`${url}/versions/${id}/duplicate`, data)

export const updateVersion = (id: string, data: Obj) =>
  apiUtils.PUT(`${url}/versions/${id}`, data)

export const deleteVersion = (id: string) =>
  apiUtils.DELETE(`${url}/versions/${id}`)

// ============================================================================
// Parts API
// ============================================================================

export const getParts = (
  versionId?: string,
  category?: string,
  options: AxiosRequestConfig = {},
) => {
  const params: Obj = {}
  if (versionId) params.version_id = versionId
  if (category) params.category = category
  return apiUtils.GET(`${url}/parts`, merge({ params }, options))
}

export const getPart = (id: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/parts/${id}`, options)

export const createPart = (data: Obj) => apiUtils.POST(`${url}/parts`, data)

export const updatePart = (id: string, data: Obj) =>
  apiUtils.PUT(`${url}/parts/${id}`, data)

export const deletePart = (id: string) => apiUtils.DELETE(`${url}/parts/${id}`)

// ============================================================================
// Routings API
// ============================================================================

export const getRoutings = (
  versionId?: string,
  options: AxiosRequestConfig = {},
) => {
  const params: Obj = {}
  if (versionId) params.version_id = versionId
  return apiUtils.GET(`${url}/routings`, merge({ params }, options))
}

export const getRouting = (id: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/routings/${id}`, options)

export const createRouting = (data: Obj) =>
  apiUtils.POST(`${url}/routings`, data)

export const updateRouting = (id: string, data: Obj) =>
  apiUtils.PUT(`${url}/routings/${id}`, data)

export const deleteRouting = (id: string) =>
  apiUtils.DELETE(`${url}/routings/${id}`)

// ============================================================================
// Mappings API
// ============================================================================

export const getMappings = (
  versionId?: string,
  options: AxiosRequestConfig = {},
) => {
  const params: Obj = {}
  if (versionId) params.version_id = versionId
  return apiUtils.GET(`${url}/mappings`, merge({ params }, options))
}

export const getMapping = (id: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/mappings/${id}`, options)

export const createMapping = (data: Obj) =>
  apiUtils.POST(`${url}/mappings`, data)

export const updateMapping = (id: string, data: Obj) =>
  apiUtils.PUT(`${url}/mappings/${id}`, data)

export const deleteMapping = (id: string) =>
  apiUtils.DELETE(`${url}/mappings/${id}`)

// ============================================================================
// Conduit Transitions API
// ============================================================================

export const getConduitTransitions = (
  versionId?: string,
  options: AxiosRequestConfig = {},
) => {
  const params: Obj = {}
  if (versionId) params.version_id = versionId
  return apiUtils.GET(`${url}/conduit-transitions`, merge({ params }, options))
}

export const getConduitTransition = (
  id: string,
  options: AxiosRequestConfig = {},
) => apiUtils.GET(`${url}/conduit-transitions/${id}`, options)

export const createConduitTransition = (data: Obj) =>
  apiUtils.POST(`${url}/conduit-transitions`, data)

export const updateConduitTransition = (id: string, data: Obj) =>
  apiUtils.PUT(`${url}/conduit-transitions/${id}`, data)

export const deleteConduitTransition = (id: string) =>
  apiUtils.DELETE(`${url}/conduit-transitions/${id}`)
